function modal () {
  const html = document.querySelector('html')
  const modaLinks = document.querySelectorAll('.open-modal')
  const btnClose = document.querySelectorAll('.modal .close')
  const allModals = document.querySelectorAll('.modal')
  // console.log(btnClose);

  function populateBrandModal (trigger) {
    const name = trigger.dataset.brandName || ''
    const logo = trigger.dataset.brandLogo || ''
    const level = trigger.dataset.brandLevel || ''
    const url = trigger.dataset.brandUrl || ''
    const socio = trigger.dataset.brandSocio === 'true'
    let partner = ''
    let badgets = []
    
    try {
      partner = JSON.parse(trigger.dataset.brandPartner || '""')
    } catch (e) {
      partner = ''
    }
    
    try {
      badgets = JSON.parse(trigger.dataset.brandBadgets || '[]')
    } catch (e) {
      badgets = []
    }

    // console.log('Brand data:', { name, logo, level, url, partner, badgets, socio })

    const modalLogo = document.getElementById('modal-brand-logo')
    const modalInfo = document.getElementById('modal-brand-info')
    const modalLabelPartner = document.getElementById('modal-brand-label-partner')
    const modalLabelSocio = document.getElementById('modal-brand-label-socio')
    const modalLevel = document.getElementById('modal-brand-level')
    const modalUrl = document.getElementById('modal-brand-url')
    const modalPartner = document.getElementById('modal-brand-partner')
    const modalPartnerImg = document.getElementById('modal-brand-partner-img')
    const modalBadgets = document.getElementById('modal-brand-badgets')

    // console.log('Modal elements:', { modalLogo, modalLevel, modalUrl, modalPartner, modalBadgets })

    if (modalLogo) {
      modalLogo.src = logo
      modalLogo.alt = name
    }
    
    const hasPartner = partner && (Array.isArray(partner) ? partner.length > 0 : partner !== '')
    const hasLevel = level && level.trim() !== ''
    
    // Toggle label visibility based on socio
    if (modalLabelPartner) modalLabelPartner.style.display = socio ? 'none' : ''
    if (modalLabelSocio) modalLabelSocio.style.display = socio ? '' : 'none'

    if (modalInfo) {
      if (!hasPartner && !hasLevel && !socio) {
        modalInfo.style.display = 'none'
      } else {
        modalInfo.style.display = ''
      }
    }
    
    if (modalLevel) {
      if (socio) {
        modalLevel.style.display = 'none'
      } else if (hasPartner) {
        modalLevel.style.display = ''
        modalLevel.innerHTML = ''
        const partners = Array.isArray(partner) ? partner : [partner]
        partners.forEach((p) => {
          const img = document.createElement('img')
          img.src = p
          img.alt = name + ' partner badge'
          modalLevel.appendChild(img)
        })
      } else if (hasLevel) {
        modalLevel.style.display = ''
        modalLevel.textContent = level
      } else {
        modalLevel.style.display = ''
        modalLevel.textContent = ''
      }
    }
    
    if (modalUrl) modalUrl.href = url

    if (modalPartner && modalPartnerImg) {
      modalPartner.style.display = 'none'
    }

    if (modalBadgets) {
      modalBadgets.innerHTML = ''
      if (badgets.length > 0) {
        badgets.forEach((badge) => {
          const img = document.createElement('img')
          img.src = badge
          img.alt = name + ' badge'
          img.className = 'modal-brand__badge'
          modalBadgets.appendChild(img)
        })
      }
    }
  }

  function closeModal (html, modal) {
    html.dataset.modal = 'off'
    modal.dataset.show = 'off'
  }

  // Función para manejar el clic fuera del elemento
  function handleClickOutside (html, modal, modalContent, modalType, event) {
    if (!modalContent.contains(event.target)) {
      // console.log('Se hizo clic fuera del elemento.');

      if (modalType === 'gallery') {
        setTimeout(() => gallerySwiper.destroy(), 1000)
      }

      closeModal(html, modal)
    }
  }

  // Event delegation para .card-alianzas (funciona con GSAP Draggable)
  document.addEventListener('click', (e) => {
    const cardAlianza = e.target.closest('.card-alianzas.open-modal')
    if (cardAlianza) {
      e.preventDefault()
      e.stopPropagation()
      
      const modaLink = cardAlianza.dataset.modal
      const modal = document.querySelector('.modal[data-modal=' + modaLink + ']')
      if (!modal) return
      
      const modalType = modal.dataset.type
      html.dataset.modal = 'on'
      modal.dataset.show = 'on'
      
      if (modalType === 'brand') {
        populateBrandModal(cardAlianza)
      }
    }
  })

  // Eventos directos para otros .open-modal (no card-alianzas)
  modaLinks.forEach((btnModal) => {
    if (btnModal.classList.contains('card-alianzas')) return // Skip, handled by delegation
    
    btnModal.onclick = (e) => {
      e.preventDefault()
      e.stopPropagation() // Detiene la propagación del evento

      /* open modal */
      const modaLink = btnModal.dataset.modal

      const modal = document.querySelector(
        '.modal[data-modal=' + modaLink + ']'
      )

      const modalType = modal.dataset.type
      html.dataset.modal = 'on'
      modal.dataset.show = 'on'

      /* video play */
      if (modalType === 'video') {
        const modalVideo = modal.querySelector('video')
        modalVideo.play()
        modal.addEventListener('click', (e) => {
          modalVideo.pause()
        })
      }

      /* iframe play */
      if (modalType === 'iframe') {
        const modalIframe = modal.querySelector('iframe')
        const modalIframeSrc = modalIframe.dataset.src
        modalIframe.set('src', modalIframeSrc)
        modal.addEventListener('click', (e) => {
          modalVideo.pause()
        })
      }

      /* brand modal - populate dynamically */
      if (modalType === 'brand') {
        populateBrandModal(btnModal)
      }
    } // click
  })

  // Cerrar Modal al clickear fuera del contenido
  allModals.forEach((modal) => {
    modal.addEventListener('click', (event) => {
      const modalContent = modal.querySelector('.modal-box')
      const modalType = modal.dataset.type
      handleClickOutside(html, modal, modalContent, modalType, event)
    })
  })

  // Cerrar Modal al clickear el botón cerrar
  if (btnClose) {
    btnClose.forEach((close) => {
      close.addEventListener('click', (e) => {
        e.preventDefault()

        const thisModal = close.closest('.modal')

        thisModal.dataset.show = 'off'

        setTimeout(() => {
          html.dataset.modal = 'off'
        }, 300)
      })
    })
  } // btnClose
}

export default modal
